news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 케이잡스와 상호 협력 및 파트너십 구축을 위한 업무협약 체결</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_13.png"></figure>
                                <br>
                                <br>
                              종합교육기업 에듀윌(대표 양형남)이 지난 13일, 서울 구로구에 위치한 에듀윌 본사에서 고용서비스 전문기업 케이잡스(대표 김우진)와 상호 협력 및 파트너십 구축을 위한 업무협약을 체결했다.
                              <br><br>
                              이번 협약을 통해 에듀윌은 케이잡스와 대한민국 교육 서비스의 다양성을 알리고 K-에듀의 위상을 높이는데 힘을 합친다. 아울러 케이잡스의 국내외 전직 지원자들에게 에듀윌의 전문 자격증 및 직무 교육 프로그램을 제공해 전직 기회를 증대시키는데 기여할 예정이다.
                              <br><br>
                              이날 협약식은 양형남 에듀윌 대표와 김우진 케이잡스 대표를 비롯해 양사 관계자 10여 명이 참석한 가운데 진행되었다. 
                              <br><br>
                              양형남 에듀윌 대표는 인사말을 통해 “내국인 뿐만 아니라 외국인 근로자를 대상으로 고용 및 취업 서비스를 지원하는 케이잡스와의 이번 협력은 사업 확장과 서비스 다양화 등 양사 모두가 성장할 수 있는 기회”라며, “에듀윌의 교육 프로그램을 통해 전직 지원자들에게 더 많은 길이 열리길 바란다”고 말했다. 
                              <br><br>
                              이에 케이잡스의 김우진 대표는 “에듀윌의 맞춤형 교육을 통해 전직 지원자들의 취업 역량을 더욱 강화시킬 수 있을 것으로 기대한다”며, “교육 콘텐츠 및 프로그램의 공동 개발 등 에듀윌과 긴밀하게 협력해 나갈 것”이라고 화답했다. 
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news14" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, (주)산타와 손잡고 에듀테크 속도 낸다</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news12" data-value="315283">
                                  <strong>다음</strong>
                                  <span>'에듀윌 공인중개사 합격서', 판매 즉시 온라인서점 국내도서 전체 베스트셀러 올라</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
